import React, { useEffect, useState } from 'react'
import { downloadAnki, getCard } from './actions';
import { useParams } from 'react-router-dom';
import { Result } from 'antd';
import { AiOutlineCheck, AiOutlineQuestion } from 'react-icons/ai';
import i18n from '../../lib/i18n';
import styles from './FlashcardsView.module.scss'
import Card from './components/Card/Card';
import config from '../../config';

function FlashcardsView() {
  const [loaded, setLoaded] = useState(false);
  const [download, setDownload] = useState(false);
  const [replay, setReplay] = useState(false);
  const [cards, setCards] = useState([]);
  const [category, setCategory] = useState({});
  const [activeCard, setActiveCard] = useState(0);
  let { id } = useParams();

  const getData = async () => {
    try {
      const {cards, category} = await getCard(id);
      if(category){
        document.title = category.name;
      }
      setLoaded(true)
      setCards(cards)
      if(cards.length){
        setActiveCard(0)
      }
    } catch (error) {
      setLoaded(true)
      console.log("🚀 ~ getData ~ error:", error)
    }
  }

  useEffect(() => {
    getData();
  }, [])

  const changeCard = (index) => {
    setActiveCard(index)
    setReplay(false)
  }

  const onOpen = () => {
    if(cards.length - 1 == activeCard){
      setReplay(true)
    }
  }

  const onDownloadAnki = async () => {
    // Ignore repeat clicks while the deck is being built
    if (download) return
    try {
      setDownload(true) 
      const data = await downloadAnki(id);
      console.log("🚀 ~ onDownloadAnki ~ data:", data)
      if(data?.filename){
        window.open(config.apiUrl + '/api/flashcards/download/' + encodeURIComponent(data.filename), '_blank');
      }
      setDownload(false)
    } catch (error) {
      console.log("🚀 ~ onDownloadAnki ~ error:", error)
      setDownload(false)
    }
  }


  const card = cards[activeCard];
  if(!loaded){
    return null;
  }

  if(cards.length == 0){
    return <Result
      status="500"
      title={i18n('titleNotFoundCard')}
      subTitle={i18n('msgNotFoundCard')}
    />
  }

  return (
    <div className={styles["CardView"]}>
      {download && <div className={styles.loader} role="status" aria-live="polite">
        <div className={styles.loader_panel}>
          <div className={styles.deck} aria-hidden="true">
            <span className={styles.deck_back} />
            <span className={styles.deck_middle} />
            <span className={styles.deck_flip}>
              <span className={styles.face_front}><AiOutlineQuestion /></span>
              <span className={styles.face_back}><AiOutlineCheck /></span>
            </span>
          </div>
          <div className={styles.loader_title}>{i18n('downloadFileAnki')}</div>
          <div className={styles.progress}><span /></div>
        </div>
      </div>}
      {replay && <div className={styles["replay"]}>
        <div className={styles["text"]}>{i18n('cardCongratulations')}</div>
        <button className='btn btn-outline-secondary' onClick={() => {changeCard(0)}}>{i18n('cardreplay')}</button>
      </div>}
      {card && <Card
        card={card}
        category={category}
        current={activeCard+1} 
        count={cards.length} 
        setCurrent={(v) => changeCard(v)}
        prevId={activeCard-1}
        nextId={cards[activeCard+1] ? activeCard+1 : -1}
        onOpen={onOpen}
        downloadAnki={onDownloadAnki}
      />}
    </div>
  )
}

export default FlashcardsView